<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Excel Dosyası</label>
            <v-file-uploader v-model="value" :accept="['xlsx','xls']" value-parameter="File"></v-file-uploader>
            <div class="mt-50">
                <small><b>Kolon Sırası: </b>Dosya Numarası, Tebliğ Tarihi, Toplam Borç Tutarı, Sabit(E/H), Devlet Dairesi(E/H), Aktif(E/H), Kabul Edildi(E/H), Ödeme Tarihi, Ödeme Dönemi(AA/YYYY), Ödeme Tutarı, Ödeme Onaylandı(E/H)</small>
            </div>
        </div>
    </div>
</template>

<script>
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
export default {
    components:{
        VFileUploader
    },
    props:{
        value:Object
    }
}
</script>
